// Originally generated from the single-file app (index.html) during the React migration.
// Edit freely: this file is now the source of truth.
import type { TranslationTable } from "./translationKeys";

export const NO_TRANSLATIONS: TranslationTable = {
  syncToDbNoRows: "Ingen gyldige rader (med ID) å importere.",
  syncToDbDone: "Importerte {count} tiltak til databasen.",
  syncToDbSystemDone: "Systemanalyse: {criteria} kriterierader og {assessments} vurderingsrader.",
  syncToDbNoSystem: "Ingen Annex4-ark i filen; eksisterende systemanalyse er uendret.",
  syncToDbFailed: "Import feilet:",
  syncToDbPartial: "Tiltakene er importert, men systemanalysen feilet. Prøv importen på nytt:",
  localFileError: "Kunne ikke lese filen:",
  logout: "Logg ut",
  title: "Oversikt forebyggende tiltak",
  tabList: "Tiltaksliste",
  tabMatrix: "Tiltaksmatrise",
  tabStats: "Statistikk",
  tabSystem: "Systemanalyse",
  tabAdmin: "Admin",
  listTitle: "Tiltaksliste",
  listNumber: "ID",
  listName: "Tiltaksnavn",
  listLocation: "Lokasjon",
  arena: "Arena",
  listColor: "Klassifisering",
  listLinks: "Lenker",
  listEdit: "Rediger",
  listActions: "Handlinger",
  saveButton: "Lagre",
  deleteButton: "Slett tiltak",
  deleteConfirm: "Er du sikker på at du vil slette dette tiltaket?",
  editTitleRequired: "Tittel kan ikke være tom.",
  editSaveError: "Kunne ikke lagre endringer.",
  editRefreshError:
    "Tiltaket ble lagret, men listen kunne ikke oppdateres. Last inn siden på nytt.",
  editDeleteError: "Kunne ikke slette tiltaket.",
  editApproveError: "Kunne ikke publisere tiltaket.",
  editReturnError: "Kunne ikke sette tiltaket tilbake til kladd.",
  approveButton: "Publiser",
  returnButton: "Sett tilbake til kladd",
  returnToDraftConfirm: "Vil du sette det innsendte tiltaket tilbake til kladd? Respondenten kan deretter redigere og sende inn på nytt.",
  returnToDraftPublishedConfirm: "Vil du sette det publiserte tiltaket tilbake til kladd? Tiltaket fjernes fra matrisevisningen og statistikken til det godkjennes på nytt.",
  feedbackReturnDialogTitle: "Sett tiltak tilbake til kladd",
  feedbackCommentLabel: "Kommentar til respondent (valgfritt)",
  feedbackCommentPlaceholder: "Beskriv hva som bør rettes eller suppleres før ny innsending.",
  feedbackCommentHint: "Vises bare for respondenten og autoriserte administratorer.",
  feedbackRecipientMissing: "Tiltaket har ingen tilknyttet respondent. Det kan settes tilbake til kladd, men ikke sendes en kommentar.",
  feedbackTitle: "Tilbakemelding fra administrator",
  feedbackPendingTitle: "Tilbakemeldinger som ikke er kvittert ut ({count})",
  feedbackLater: "Vis senere",
  feedbackAcknowledge: "Kvitter ut",
  feedbackAcknowledgeError: "Kunne ikke kvittere ut tilbakemeldingen.",
  feedbackAwaitingAcknowledgement: "Venter på utkvittering fra respondent.",
  feedbackRemainsPending: "Tilbakemeldingen er fortsatt ubehandlet og vil vises neste gang du åpner tiltaket.",
  feedbackPrevious: "Tidligere tilbakemeldinger ({count})",
  feedbackAcknowledged: "Kvittert ut",
  feedbackNewCount: "{count} ny(e) tilbakemelding(er) fra administrator",
  feedbackListError: "Kunne ikke hente tilbakemeldingsvarsler.",
  saveDraftButton: "Lagre kladd",
  submitButton: "Send inn",
  statusDraft: "Kladd",
  statusSubmitted: "Innsendt",
  statusApproved: "Publisert",
  classificationHeading: "Klassifisering",
  workingCommentsHeading: "Arbeidskommentarer",
  workingCommentsHint: "Interne notater. Vises bare for administratorer.",
  workingCommentsEmpty: "Ingen arbeidskommentarer.",
  lastUpdated: "Sist oppdatert",
  createdAt: "Opprettet",
  changeHistory: "Endringshistorikk",
  historyEmpty: "Ingen registrerte endringer ennå.",
  historyLoadError: "Kunne ikke hente endringshistorikk.",
  historyMore: "Vis eldre hendelser",
  historyCreated: "Tiltak opprettet",
  historyUpdated: "Tiltak oppdatert",
  historyStatus: "Status endret",
  historyDeleted: "Tiltak slettet",
  historyCustomField: "Egendefinert felt endret",
  historyComment: "Arbeidskommentar endret",
  historyQuestionnaire: "Spørreskjemasvar endret",
  historyChangedField: "Endret felt",
  historyCharacters: "tegn",
  updatedBy: "av",
  updatedByUnknown: "ukjent",
  listStatus: "Status",
  newInterventionButton: "+ Nytt tiltak",
  respondentIntroTitle: "Velkommen! Her melder du inn forebyggende tiltak",
  respondentIntroText:
    "Registrer de forebyggende tiltakene i {location}. I listen under ser og redigerer du tiltakene du har registrert.",
  respondentStepRegisterTitle: "Registrer",
  respondentStepRegisterText:
    "Lagre underveis som kladd. Send inn når tiltaket er ferdig beskrevet.",
  respondentStepReviewTitle: "Vurderes",
  respondentStepReviewText:
    "Innsendte tiltak låses og vurderes. Admin kan sende tiltaket tilbake som kladd.",
  respondentStepPublishedTitle: "Vises i tiltaksmatrisen",
  respondentStepPublishedText: "Publiserte tiltak blir synlige i tiltaksmatrisen.",
  respondentSensitiveTitle: "Ikke registrer sensitive opplysninger.",
  respondentSensitiveText:
    "Unngå personidentifiserbar informasjon eller annen sensitiv informasjon i beskrivelsene.",
  respondentContact: "Spørsmål om verktøyet? Kontakt administratoren for din lokasjon.",
  respondentIntroShow: "Slik fungerer det",
  respondentIntroHide: "Skjul veiledning",
  respondentListTitle: "Dine innrapporterte tiltak",
  newInterventionBadge: "Nytt tiltak",
  interventionEditorTitle: "Rediger tiltak",
  interventionEditorIntroduction:
    "Fyll ut informasjonen i seksjonene nedenfor. Lagreknappen er tilgjengelig nederst mens du arbeider.",
  respondentNoSubmissions: "Du har ikke registrert noen tiltak ennå.",
  detailsAge: "Alder",
  detailsYears: "år",
  detailsNoDescription: "Ingen beskrivelse.",
  detailsNoSources: "Ingen kilder registrert.",
  detailsSources: "Kilder",
  formDisplayInformationTab: "Visningsinformasjon",
  formDataTab: "Skjemadata",
  formDataNotice:
    "Skjemadata er kun tilgjengelige for innsender, lokaladministrator i tiltakets lokasjon og superadministrator. Visningsinformasjon er synlig for alle som har lesetilgang til tiltaket.",
  formFetchDisplayInformation: "Hent visningsinformasjon fra skjemadata",
  formCopyConfirm:
    "Dette erstatter public-feltene som er angitt i skjemaets kopieringsregler med verdier fra skjemasvarene, også når svarene er tomme. Endringene publiseres når du trykker Lagre. Fortsette?",
  formCopyDone:
    "Skjemasvarene er kopiert til public-feltene etter skjemaets kopieringsregler. Trykk Lagre for å lagre endringene.",
  formLoadError:
    "Kunne ikke laste privat skjema. Kontroller at SQL-migreringen er kjørt, og åpne tiltaket på nytt.",
  formUnknownVersion: "Skjemaoppsettet for denne ID-en og versjonen er ikke tilgjengelig i koden.",
  formNoResponse: "Det finnes ingen innrapporterte skjemasvar på dette tiltaket.",
  formInvalidNumber:
    "Tallfeltene må inneholde gyldige, ikke-negative heltall. Fra-alder kan ikke være høyere enn til-alder.",
  formChooseLocation: "Velg en registrert lokasjon for å laste riktig skjema.",
  adminLocationQuestionnaire: "Skjema for nye innrapporteringer",
  adminGdprTitle: "GDPR",
  adminGdprDescription:
    "Se antall innsendte skjemasvar per lokasjon og slett svarene etter gjeldende lagringsrutiner. Public-visningene av tiltakene beholdes.",
  adminGdprColId: "ID",
  adminGdprColName: "Lokasjon",
  adminGdprColCount: "Antall skjemasvar",
  adminGdprColActions: "Handling",
  adminGdprResponseCount: "{count} skjemasvar",
  adminGdprResponsesDelete: "Slett skjemasvar",
  adminGdprResponsesConfirm:
    'Vil du slette alle {count} innrapporterte skjemasvar for lokasjonen "{location}"? Public-visningene av tiltakene beholdes. Denne handlingen kan ikke angres.',
  adminGdprResponsesDeleteSuccess:
    "Slettet {count} skjemasvar for {location}. Public-visningene av tiltakene er beholdt.",
  adminGdprResponsesDeleteError: "Kunne ikke slette skjemasvar.",
  formTitle: "Tittel",
  formDescription: "Beskrivelse",
  formYoungest: "Yngste alder",
  formOldest: "Eldste alder",
  formLinksLabel: "Lenker (skilt med semikolon)",
  respondentPageTitle: "Innrapportering av tiltak",
  listEmpty: "Ingen tiltak matcher de valgte filtrene.",
  labelView: "Visning:",
  location: "Lokasjon",
  objective: "Målsetting",
  labelFile: "Bruk lokal Excel-fil:",
  fileButton: "Velg fil...",
  syncToDbButton: "Importer til database",
  syncToDbButtonWorking: "Importerer...",
  authGateTitle: "Intervention Matrix",
  authGateSubtitle: "Logg inn med din e-postadresse for å fortsette",
  authEmailLabel: "E-post",
  authPasswordLabel: "Passord",
  authLoginButton: "Logg inn",
  authForgotButton: "Glemt passord?",
  authErrorGeneric: "Innlogging feilet. Sjekk e-post og passord.",
  authRoleInvalid:
    "Kontoen har en ukjent eller utdatert rolle. Kontroller rollemigreringen i Supabase, og logg ut og inn igjen.",
  authSessionExpired: "Innloggingsøkten kunne ikke bekreftes. Logg ut og inn igjen.",
  supabaseNotConfigured:
    "Innloggingen er ikke satt opp for denne installasjonen. Kontakt administrator (SUPABASE_URL og SUPABASE_ANON_KEY mangler).",
  authResetSent: "Hvis e-posten finnes, er det sendt en lenke for å tilbakestille passord.",
  authResetNeedsEmail: "Skriv inn e-postadressen din først.",
  authSetPasswordSubtitle: "Velkommen! Sett et passord for å fullføre kontoen din.",
  authNewPasswordLabel: "Nytt passord",
  authConfirmPasswordLabel: "Bekreft passord",
  authSetPasswordButton: "Sett passord",
  authPasswordMismatch: "Passordene er ikke like.",
  authSetPasswordError: "Kunne ikke sette passord. Prøv igjen, eller be om en ny lenke.",
  adminPanelTitle: "Brukeradministrasjon",
  adminInviteHeading: "Inviter ny bruker",
  adminInviteEmailLabel: "E-post",
  adminInviteRoleLabel: "Rolle",
  adminInviteRoleLocalAdmin: "Lokal administrator",
  adminInviteRoleLocalReader: "Lokal lesetilgang",
  adminInviteRoleRespondent: "Respondent",
  adminInviteRoleRespondentRead: "Respondent med lesetilgang",
  adminInviteRoleSuperAdmin: "Superadministrator",
  adminInviteLocationLabel: "Lokasjon",
  adminInviteLocationPlaceholder: "Velg lokasjon",
  adminInviteSubmit: "Inviter",
  adminUsersHeading: "Eksisterende brukere",
  adminColEmail: "E-post",
  adminColRole: "Rolle",
  adminColLocation: "Lokasjon",
  adminColActions: "Handling",
  adminDeleteButton: "Slett",
  adminDeleteConfirm: "Er du sikker på at du vil slette denne brukeren?",
  adminInviteSuccess: "Bruker invitert.",
  adminInviteError: "Kunne ikke invitere bruker.",
  adminInviteLocationRequired: "Lokasjon er påkrevd for denne rollen.",
  adminUsersLoadError: "Kunne ikke hente brukerliste.",
  adminUsersEmpty: "Ingen brukere funnet.",
  adminDeleteError: "Kunne ikke slette bruker.",
  adminEditButton: "Rediger",
  adminCancelButton: "Avbryt",
  adminEditSelfHint: "Du kan ikke endre din egen rolle.",
  adminEditNotAllowedHint:
    "Lokale administratorer kan bare endre lesere og respondenter i egen lokasjon.",
  adminRoleUpdated:
    "Rollen er endret. Den gjelder fullt ut når brukeren logger inn på nytt, senest innen én time.",
  adminRoleUpdateError: "Kunne ikke endre rollen.",
  adminLocationsTitle: "Lokasjonsadministrasjon",
  adminLocationCreateHeading: "Opprett ny lokasjon",
  adminLocationIdLabel: "ID (to tegn)",
  adminLocationNameLabel: "Navn",
  adminLocationSubmit: "Opprett",
  adminLocationsHeading: "Eksisterende lokasjoner",
  adminLocationColId: "ID",
  adminLocationColName: "Navn",
  adminLocationIdLengthError: "Lokasjons-ID må bestå av nøyaktig to tegn.",
  adminLocationCreateSuccess: "Lokasjon opprettet.",
  adminLocationCreateError: "Kunne ikke opprette lokasjon.",
  adminLocationsLoadError: "Kunne ikke hente lokasjoner.",
  adminLocationsEmpty: "Ingen lokasjoner funnet.",
  adminLocationDeleteConfirm: "Vil du virkelig slette lokasjonen",
  adminLocationDeleteError: "Kunne ikke slette lokasjon.",
  adminLocationDeleteAssignedError:
    "Lokasjonen er tildelt brukere eller har tilknyttede tiltak, og kan ikke slettes.",
  adminAgeGroupsTitle: "Alderskolonner i tiltaksmatrisen",
  adminAgeGroupsDescription:
    "Velg 1–8 kolonner med norske navn og sammenhengende aldersintervaller uten overlapp (0–120 år, inklusive). Oversettelser vedlikeholdes under Språk og oversettelser.",
  adminAgeGroupsName: "Kolonnenavn",
  adminAgeGroupsFrom: "Fra-år",
  adminAgeGroupsTo: "Til-år",
  adminAgeGroupsRemove: "Fjern kolonne",
  adminAgeGroupsAdd: "Legg til kolonne",
  adminAgeGroupsSave: "Lagre alderskolonner",
  adminAgeGroupsSaved: "Alderskolonnene er lagret.",
  adminAgeGroupsLoadError: "Kunne ikke hente alderskolonner. Last inn siden på nytt.",
  adminAgeGroupsSaveError: "Kunne ikke lagre alderskolonner.",
  adminAgeGroupsInvalidCount: "Du må ha mellom 1 og 8 kolonner.",
  adminAgeGroupsInvalidName: "Alle kolonner må ha et navn.",
  adminAgeGroupsInvalidRange:
    "Aldersgrensene må være hele tall fra 0 til 120, med fra-år mindre enn eller lik til-år.",
  adminAgeGroupsInvalidContinuous:
    "Intervallene må være sammenhengende uten overlapp, fra venstre mot høyre. Neste fra-år må være forrige til-år + 1.",
  adminAgeGroupsInvalidKey: "Kolonnene har ugyldige identifikatorer. Last inn siden på nytt.",
  adminArenasTitle: "Arenaer / rader i tiltaksmatrisen",
  adminArenasDescription:
    "Definer valgfritt antall arenaer (minst én) med norske navn og sorteringsrekkefølge. Laveste tall vises først; likt tall sorteres etter navn. Ved fjerning beholdes tiltakene med tom arena. Oversettelser vedlikeholdes under Språk og oversettelser.",
  languagesTitle: "Språk og oversettelser",
  adminSubmenuLabel: "Admin-innstillinger",
  adminMenuUsers: "Brukere",
  adminMenuLocations: "Lokasjoner",
  adminMenuAgeGroups: "Alderskolonner",
  adminMenuArenas: "Arenaer",
  adminMenuExport: "Eksport",
  adminDefaultUrlTitle: "Standardvisning",
  adminDefaultUrlDescription: "Standardparametere brukes bare når de ikke er angitt i lenken. Dette endrer aldri brukerens tilganger. Datasettparameteren gjelder bare Excel-modus.",
  adminDefaultUrlLabel: "Standardparametere (URL)",
  adminDefaultUrlSave: "Lagre standardvisning",
  adminDefaultUrlSaved: "Standardvisningen er lagret. Åpne siden på nytt for å se effekten.",
  adminDefaultUrlError: "Ugyldige standardparametere.",
  adminDefaultUrlViewUnavailable: "Standardvisningen finnes ikke eller er skjult. Gjør visningen synlig under Visninger",
  adminExportTitle: "Eksporter data (CSV)",
  adminExportDescription:
    "Last ned data som CSV med de samme kolonnene som Excel-importen bruker. Lokale administratorer eksporterer data for egen lokasjon.",
  adminExportDatasetLabel: "Data",
  adminExportDatasetInterventions: "Tiltak",
  adminExportDatasetSystemData: "Systemanalyse – vurderinger (Annex4_Data)",
  adminExportDatasetSystemCriteria: "Systemanalyse – kriterier (Annex4_Criterion)",
  adminExportLocationLabel: "Lokasjon",
  adminExportAllLocations: "Alle lokasjoner",
  adminExportButton: "Eksporter CSV",
  adminExportTemplateOnly: "Tom importmal (kun kolonneoverskrifter)",
  adminExportTemplateButton: "Last ned tom CSV-mal",
  adminExportTemplateDone: "Lastet ned tom CSV-mal.",
  adminExportWorking: "Eksporterer …",
  adminExportDone: "Eksporterte {count} rader.",
  adminExportEmpty: "Fant ingen rader å eksportere.",
  adminExportError: "Kunne ikke eksportere data.",
  adminExportNoLocation: "Brukeren din har ingen lokasjon. Kontakt en superadministrator.",
  adminExportSharedNote: "Kriteriene er felles for alle lokasjoner og eksporteres samlet.",
  adminMenuExperimental: "Eksperimentelle funksjoner",
  adminExperimentalTitle: "Eksperimentelle funksjoner",
  adminExperimentalDescription:
    "Funksjoner under utvikling som kan slås på for testing. De kan endres eller fjernes uten varsel.",
  adminExperimentalFeedbackLabel: "Kommentar ved tilbakesending av tiltak",
  adminExperimentalFeedbackDescription: "Lar administrator legge ved en kommentar når tiltak sendes tilbake til kladd. Respondenten kan kvittere ut tilbakemeldingen. Avslått som standard.",
  adminExperimentalOverTimeLabel: "Systemanalyse over tid",
  adminExperimentalOverTimeDescription:
    "Legger til visningen «Over tid» i Systemanalyse, som viser hvordan hvert sjekkpunkt har utviklet seg de siste årene. Gjelder alle brukere.",
  adminExperimentalSaved: "Endringen er lagret for alle brukere.",
  adminExperimentalSaveError: "Kunne ikke lagre endringen.",
  languagesDescription:
    "Engelsk er kildespråk. Oversett grensesnitt, arenaer, alderskolonner og klassifikasjoner i gruppene nedenfor. Tom oversettelse bruker engelsk. Behold plassholdere som {name} i meldingene. Tiltaksinnhold oversettes ikke her. Lagre nye arenaer og alderskolonner først.",
  dictionaryNavigation: "Grensesnitt: navigasjon og søk",
  dictionaryAdmin: "Grensesnitt: administrasjon og språk",
  dictionaryAuth: "Grensesnitt: innlogging",
  dictionaryForms: "Grensesnitt: tiltaksskjema og arbeidsflyt",
  dictionarySystem: "Grensesnitt: systemanalyse",
  dictionaryStatistics: "Grensesnitt: statistikk",
  dictionaryGeneral: "Grensesnitt: generelle tekster og visning",
  dictionaryClassifications: "Klassifikasjon",
  dictionaryCategories: "Kolonnekategorier",
  dictionaryObjectives: "Målsettinger",
  dictionarySearch: "Søk i oversettelser",
  dictionarySearchEmpty: "Ingen treff.",
  languageCsvExport: "Eksporter CSV",
  languageCsvImport: "Importer CSV",
  languageCsvHint:
    "Eksport inkluderer alle tekster, språk og ulagrede endringer. Import oppdaterer oppføringer og legger til nye språk som utkast. Lagre etter import.",
  languageCsvExported: "CSV-filen er eksportert.",
  languageCsvImported:
    "Importert {entries} oppføringer og {languages} nye språk som utkast. Trykk Lagre språk og oversettelser for å lagre.",
  languageCsvConfirm:
    "Importer {entries} oppføringer og {languages} nye språk? Tekster i filen erstatter tilsvarende utkast. Øvrige oppføringer beholdes. Endringer gjelder først ved lagring.",
  languageCsvError: "Kunne ikke behandle CSV-filen.",
  languageCsvSettings: "Rett ugyldige språk eller engelske originaler før eksport/import.",
  languageCsvSyntax: "Ugyldig CSV: kontroller anførselstegn og skilletegn.",
  languageCsvHeader: "Første rad må være section;key;en og eventuelle øvrige unike språkkoder.",
  languageCsvNames: "Andre rad må være languages;name etterfulgt av navn for hvert språk.",
  languageCsvColumns: "Alle rader må ha samme antall kolonner som overskriften.",
  languageCsvKey: "Ukjent seksjon eller ugyldig tekstnøkkel.",
  languageCsvDuplicate: "Samme seksjon og tekstnøkkel forekommer flere ganger.",
  languageCsvUnregistered:
    "Filen inneholder en arena eller alderskolonne som ikke er registrert. Opprett den først.",
  languageCsvEnglish: "Engelske originaler kan ikke være tomme.",
  adminViewsTitle: "Visninger",
  adminCustomFieldsTitle: "Egendefinerte felter",
  adminCustomFieldsDescription: "Opprett og administrer ekstra informasjonsfelt for tiltak. Oversett ledetekster under Språk og oversettelser. Engelsk er grunnspråket.",
  adminCustomFieldInvalidKey: "Felt-ID må begynne med en liten bokstav og kan ellers bare inneholde små bokstaver, tall og understrek.",
  adminCustomFieldRequiredEnglish: "Du må angi et engelsk feltnavn.",
  adminCustomFieldInvalidCss: "CSS-klassen må være ett klassenavn med bokstaver, tall, bindestrek eller understrek.",
  adminCustomFieldInvalidLocation: "Du har ikke tilgang til denne lokasjonen.",
  adminCustomFieldLoadError: "Kunne ikke hente egendefinerte felter.",
  adminCustomFieldSaveError: "Kunne ikke lagre feltet.",
  adminCustomFieldDeleteError: "Kunne ikke slette feltet.",
  adminCustomFieldDeleteConfirm: "Vil du slette feltet «{name}» og alle lagrede verdier? Dette kan ikke angres.",
  adminCustomFieldNew: "Nytt egendefinert felt",
  adminCustomFieldLoading: "Laster felter …",
  adminCustomFieldEmpty: "Ingen egendefinerte felter ennå.",
  adminCustomFieldAdd: "Legg til felt",
  adminCustomFieldDefinition: "Feltdefinisjon",
  adminCustomFieldNameEn: "Feltnavn (engelsk)",
  adminCustomFieldId: "Felt-ID",
  adminCustomFieldIdHint: "Felt-ID kan ikke endres etter opprettelse. Oversettelser håndteres under Språk og oversettelser.",
  adminCustomFieldPresentation: "Visning",
  adminCustomFieldLocation: "Lokasjon",
  adminCustomFieldAllLocations: "Alle lokasjoner",
  adminCustomFieldType: "Felttype",
  adminCustomFieldSingleLine: "Tekst på én linje",
  adminCustomFieldMultiLine: "Tekst over flere linjer",
  adminCustomFieldSortOrder: "Visningsrekkefølge",
  adminCustomFieldCssClass: "CSS-klasse (valgfritt)",
  adminCustomFieldCssHint: "Oppgi navnet på en eksisterende CSS-klasse, ikke CSS-regler.",
  adminCustomFieldAdminOnly: "Kun synlig for administratorer",
  adminCustomFieldDelete: "Slett felt",
  adminCustomFieldUnsaved: "Ulagrede endringer",
  adminCustomFieldNoChanges: "Ingen ulagrede endringer",
  adminCustomFieldSaving: "Lagrer …",
  adminCustomFieldSave: "Lagre endringer",
  adminCustomFieldCreate: "Opprett felt",
  adminCustomFieldAdminBadge: "Admin",
  adminViewsDescription:
    "Rediger visninger og kategorier. Endringer gjelder først ved lagring. Innebygde visninger kan skjules, egendefinerte visninger kan slettes. ID, kildefelt og klassifikasjonstype låses etter lagring. Kategorier som brukes av tiltak kan ikke slettes. Engelske og norske navn oppdateres også i oversettelser.",
  adminViewSelect: "Velg visning",
  adminViewAdd: "Ny visning",
  adminViewDiscard: "Forkast ny visning",
  adminViewDelete: "Slett visning",
  adminViewDeleteConfirm:
    "Vil du slette visningen «{name}»? Når du lagrer, fjernes den fra visningsmenyen, detaljpanelet og tiltaksskjemaet, og klassifikasjonsverdiene i feltet «{field}» slettes fra alle tiltak, også inaktive. Dette kan ikke angres.",
  adminViewDeleteConfirmShared:
    "Vil du slette visningen «{name}»? Når du lagrer, fjernes den fra visningsmenyen, detaljpanelet og tiltaksskjemaet. Klassifikasjonsverdiene i feltet «{field}» beholdes, fordi en annen visning bruker samme felt. Slettingen kan ikke angres etter lagring.",
  adminViewsSave: "Lagre visninger",
  adminViewsSaved: "Visningene er lagret.",
  adminViewsError: "Kunne ikke lagre visninger.",
  adminViewsLoadError: "Kunne ikke laste visninger. Kontroller at supabase/schema.sql er kjørt.",
  adminViewsInvalid:
    "Kontroller obligatoriske navn, unike ID-er/koder, kategoriorden og at minst én visning er synlig.",
  adminViewId: "Visnings-ID (stabil)",
  adminViewNameEn: "Navn på engelsk",
  adminViewNameNo: "Navn på norsk",
  adminViewColumn: "Kildefelt i tiltaksdata / Excel",
  adminViewNewColumn: "Nytt klassifikasjonsfelt",
  adminViewType: "Klassifikasjonstype",
  adminViewNumeric: "Tallprefiks (0–9)",
  adminViewCategorical: "Kategorikode (små bokstaver, tall og bindestrek)",
  adminViewLayout: "Kolonneoppsett",
  adminViewOrder: "Sorteringsrekkefølge",
  adminViewVisible: "Synlig i visningsmenyen",
  adminViewChips: "Filterknapper",
  adminViewChipsHidden: "Ingen",
  adminViewChipsView: "Visningens kategorier",
  adminViewChipsObjectives: "Målsettinger",
  adminViewDetails: "Klassifikasjoner i detaljpanelet",
  adminViewCategories: "Kategorier",
  adminViewCategoryAdd: "Legg til kategori",
  adminViewCategoryCode: "Kategorikode (stabil)",
  adminViewColor: "Bakgrunnsfarge",
  adminViewPattern: "Mønster",
  adminViewSolid: "Ensfarget",
  adminViewStriped: "Striper",
  adminViewStripeColor: "Stripefarge",
  adminViewStripeBackground: "Andre stripefarge",
  adminViewTextColor: "Tekstfarge",
  adminViewTextAuto: "Automatisk",
  adminViewTextBlack: "Svart",
  adminViewTextWhite: "Hvit",
  adminViewUp: "Flytt opp",
  adminViewDown: "Flytt ned",
  adminViewRemove: "Fjern kategori",
  adminViewRemoveConfirm:
    "Vil du fjerne denne kategorien? Sletting av kategorier som brukes av tiltak blir blokkert ved lagring.",
  adminViewCategoryUsed: "Kategorien brukes av et tiltak og kan ikke fjernes.",
  adminViewUntitled: "Uten navn",
  adminViewNewBadge: "Ny",
  adminViewHiddenBadge: "Skjult",
  adminViewSectionNames: "Navn",
  adminViewSectionSource: "Datakilde",
  adminViewSectionDisplay: "Visning",
  adminViewLockedHint:
    "Låst etter lagring fordi klassifiserte tiltak er knyttet til disse verdiene.",
  adminUnsavedChanges: "Ulagrede endringer",
  adminAllChangesSaved: "Alle endringer er lagret",
  languageMaster: "Engelsk original (kildespråk)",
  languageTranslation: "Oversettelse",
  languageCode: "Språkkode (f.eks. sv eller pt-br)",
  languageName: "Språknavn",
  languageAdd: "Legg til språk",
  languageDelete: "Slett språk",
  languageDeleteConfirm:
    "Vil du virkelig slette språket «{name}»? Når du lagrer, fjernes språkknappen og språkets ordbokoversettelser. Tiltak og engelske originaler beholdes. Hvis språket er valgt, byttes det til engelsk.",
  languageSectionLanguages: "Språk",
  languageSectionCsv: "Import og eksport (CSV)",
  languageSectionTranslations: "Oversettelser",
  languageSourceBadge: "Kildespråk",
  languageKey: "Tekstnøkkel",
  languageOnlyUntranslated: "Vis bare uoversatte",
  languageUntranslatedBadge: "Uoversatt",
  languageSearchCount: "{count} treff",
  languageGroupEmpty: "Ingen tekster i denne gruppen.",
  languageAllTranslated: "Alt i denne gruppen er oversatt.",
  languagesSave: "Lagre språk og oversettelser",
  languagesSaved: "Språk og oversettelser er lagret.",
  languagesError: "Kunne ikke lagre språk og oversettelser.",
  languagesInvalid:
    "Oppgi unike språkkoder med små bokstaver og navn. Engelsk må beholdes. Engelsk original kan ikke være tom.",
  languagesLoadError: "Kunne ikke hente språk og oversettelser. Last inn siden på nytt.",
  adminArenasName: "Arenanavn",
  adminArenasOrder: "Sorteringsrekkefølge",
  adminArenasAdd: "Legg til arena",
  adminArenasRemove: "Fjern arena",
  adminArenasSave: "Lagre arenaer",
  adminArenasSaved: "Arenaene er lagret.",
  adminArenasLoadError: "Kunne ikke hente arenaer. Last inn siden på nytt.",
  adminArenasSaveError: "Kunne ikke lagre arenaer.",
  adminArenasInvalidCount: "Du må ha minst én arena.",
  adminArenasInvalidKey: "Arenaene har ugyldige identifikatorer. Last inn siden på nytt.",
  adminArenasInvalidName: "Alle arenaer må ha et navn.",
  adminArenasInvalidOrder:
    "Sorteringsrekkefølge må være et heltall mellom -2147483648 og 2147483647.",
  adminArenasRemoveConfirm:
    "Vil du virkelig fjerne arenaen «{name}»? Når du lagrer, blir Arena-feltet tømt på alle tilknyttede tiltak, også inaktive. Tiltakene slettes ikke, men vises ikke i matrisen før de får en ny arena.",
  formArenaPlaceholder: "Velg arena",
  formArenaRequired: "Velg en registrert arena.",
  formAgeRequired:
    "Fyll ut yngste og eldste alder (hele tall, yngste kan ikke være høyere enn eldste).",
  searchPlaceholder: "Søk i tiltak...",
  searchClear: "Tøm søk",
  allLocations: "Alle lokasjoner",
  locationsSelected: "lokasjoner valgt",
  allObjectives: "Alle målsettinger",
  objectivesSelected: "målsettinger valgt",
  infoDefault: "Klikk på et element i matrisen for detaljer",
  statsTitle: "Statistikk",
  tiltaksnivaTitle: "Antall tiltak etter Tiltaksnivå:",
  regionTitle: "Antall tiltak etter Lokasjon:",
  sectorTitle: "Antall tiltak etter Sektor:",
  ageTitle: "Antall tiltak etter Aldersgruppe:",
  tiltaksklasseTitle: "Antall tiltak etter Tiltaksklasse:",
  initialFilteringTitle: "Antall tiltak etter RePS initiell sortering:",
  kunnskapTitle: "Antall tiltak etter Kunnskapsnivå:",
  evidencelevelTitle: "Antall tiltak etter Evidensnivå:",
  stackedAgeTitle: "Tiltak etter Aldersgruppe og Evidensnivå",
  stackedTiltaksklasseTitle: "Tiltak etter Tiltaksklasse og Evidensnivå",
  stackedInitialFilteringTitle: "Tiltak etter RePS initiell sortering og Evidensnivå",
  stackedTiltakTitle: "Tiltak etter Tiltaksnivå og Evidensnivå",
  stackedSectorTitle: "Tiltak etter Sektor og Evidensnivå",
  forklaring: "Forklaring:",
  unclassifiedItems: "Uklassifisert",
  ikkeAngitt: "Ikke angitt",
  ingen: "Ingen",
  showLabels: "Vis titler",
  hideLabels: "Skjul titler",
  labels: "Titler",
  noLabels: "Ingen titler",
  labelsOn: "Titler: På",
  labelsOff: "Titler: Av",
  showItemIds: "Vis ID",
  hideItemIds: "Skjul ID",
  ids: "ID",
  noIds: "Ingen ID",
  idsOn: "ID: På",
  idsOff: "ID: Av",
  moreDetails: "Flere detaljer",
  detailsLevel0: "Detaljer: Færre",
  detailsLevel1: "Detaljer: Flere 1",
  detailsLevel2: "Detaljer: Flere 2",
  showMoreDetails: "Vis flere detaljer",
  hideMoreDetails: "Vis enda flere detaljer",
  hideMoreDetails2: "Skjul flere detaljer",
  listDescription: "Beskrivelse",
  readMore: "Les mer",
  showUnclassified: "Vis uklassifiserte",
  hideUnclassified: "Skjul uklassifiserte",
  unclassified: "Vis uklassifiserte",
  noUnclassified: "Skjul uklassifiserte",
  unclassifiedShow: "Uklassifiserte: Vis",
  unclassifiedHide: "Uklassifiserte: Skjul",
  showAll: "Vis alle",
  hideAll: "Skjul alle",
  showFilters: "Vis filtre",
  hideFilters: "Skjul filtre",
  filtersShow: "Filter: Vis",
  filtersHide: "Filter: Skjul",
  closeDetails: "Lukk detaljer",
  moveDetailsRight: "Flytt detaljer til høyre",
  moveDetailsBelow: "Flytt detaljer under matrisen",
  systemLocation: "Lokasjon",
  systemAnalysis: "Analyse",
  systemAbout: "Om systemanalysen",
  systemAboutTitle: "Om systemanalysen",
  systemAboutText:
    "Systemanalysen oppsummerer forebyggingssystemet i seks domener (A-F). Hvert sjekkpunkt vurderes individuelt. Fargemerkingen av område A-F er basert på aggregering av laveste underliggende score.",
  systemSummaryLabel: "Forklaring",
  systemDomain: "Systemområde",
  systemCriterion: "Kriterium",
  systemAssessment: "Score",
  systemEvidence: "Vurdering",
  systemSource: "Kilde / dokumentasjon",
  systemWorkingComment: "Arbeidskommentar",
  systemSector: "Sektor",
  systemInterventionType: "Intervensjonstype",
  systemInterventionReach: "Intervensjonsrekkevidde",
  systemNoCriteria: "Ingen sjekkpunkter tilgjengelig.",
  systemCreateAnalysis: "Opprett systemanalyse",
  systemEditAnalysis: "Rediger analyse",
  systemCreateAnalysisTitle: "Opprett systemanalyse",
  systemEditAnalysisTitle: "Rediger systemanalyse",
  systemCreateAnalysisDescription:
    "Vurder hvert kriterium i ditt eget tempo. Score og tekstfelt er valgfrie, og du kan fortsette senere.",
  systemCreateAnalysisYear: "År",
  systemCreateAnalysisLocation: "Lokasjon",
  systemCreateAnalysisCriteriaSet: "Kriterier",
  systemCreateAnalysisChooseCriteriaSet: "Velg kriteriesett …",
  systemCreateAnalysisCriteriaSetOption: "Kriteriene fra {year} ({count})",
  systemCreateAnalysisCriteriaSetRequired: "Velg hvilket kriteriesett analysen skal bygge på.",
  systemCreateAnalysisChooseScore: "Velg score",
  systemCreateAnalysisAssessment: "Vurdering",
  systemAnalysisAssessmentDetails: "Detaljert vurdering (engelsk)",
  systemAnalysisNextLevel: "Hva ble ikke oppfylt, og hva vil neste nivå kreve",
  systemCreateAnalysisCancel: "Avbryt",
  systemCreateAnalysisSave: "Lagre analyse",
  systemCreateAnalysisSuccess: "Systemanalysen er lagret.",
  systemCreateAnalysisError: "Kunne ikke lagre systemanalysen.",
  systemCreateAnalysisDuplicate:
    "Det finnes allerede en systemanalyse for denne lokasjonen og dette året.",
  systemCreateAnalysisNoCriteria: "Det finnes ingen kriterier å vurdere.",
  systemCreateAnalysisRefreshError:
    "Analysen ble lagret, men visningen kunne ikke oppdateres. Last siden på nytt.",
  systemAnalysisLastChanged: "Sist endret",
  systemAnalysisLoadError:
    "Kunne ikke hente systemanalysen. Tiltakslisten er lastet. Oppdater databasen eller kontakt administrator.",
  databaseLoadError: "Kunne ikke hente tiltak fra databasen:",
  systemNoSelection: "Velg et sjekkpunkt for detaljer",
  systemFulfilled: "Helt oppfylt",
  systemAlmostFulfilled: "Nesten helt oppfylt",
  systemPartiallyFulfilled: "Delvis oppfylt",
  systemOnlyLimited: "I liten grad oppfylt",
  systemNotFulfilled: "Ikke oppfylt",
  systemInsufficientInformation: "Ikke nok informasjon",
  systemZero: "Ikke relevant",
  systemViewLabel: "Visning",
  systemViewSingle: "Enkeltanalyse",
  systemViewOverTime: "Over tid",
  systemPeriod: "Periode",
  systemNotAssessed: "Ikke vurdert",
  systemPeriodAll: "Alle",
  systemPeriodLastTwo: "Siste 2 år",
  systemFirstAnalysisPill: "{year} · første analyse",
  systemOverTimeTitle: "Systemanalyse over tid",
  systemOverTimeNoData: "Ingen systemanalyser for denne lokasjonen ennå.",
  systemCheckpoint: "Sjekkpunkt",
  systemSince: "Siden {year}:",
  systemImproved: "{count} bedre",
  systemWorse: "{count} dårligere",
  systemOverallScore: "Samlet score",
  systemFirstAnalysisNote: "Første analyse – utgangspunktet for neste års sammenligning",
  systemFirstAnalysisTitle:
    "Dette er den første systemanalysen for {location} – boblene for {year} venter på å bli fylt ut",
  systemFirstAnalysisText:
    "Gjennomfør analysen for {year} for å se hvilke sjekkpunkter som har gått opp, og hvor dere bør sette inn innsatsen.",
  systemPlanAnalysis: "Planlegg analysen for {year}",
  systemUnknown: "Ukjent",
  systemLegendFulfilled: "Kriteriet er oppfylt.",
  systemLegendAlmostFulfilled: "Kriteriet er nesten helt oppfylt.",
  systemLegendPartiallyFulfilled: "Kriteriet er delvis oppfylt.",
  systemLegendOnlyLimited: "Kriteriet er i liten grad oppfylt.",
  systemLegendNotFulfilled: "Kriteriet er ikke oppfylt.",
  systemLegendInsufficientInformation:
    "Det finnes ikke tilstrekkelig informasjon til å vurdere kriteriet.",
  systemLegendZero: "Kriteriet er ikke relevant.",
  systemAggregateRule:
    "Fargemerkingen av område A-F er basert på aggregering av laveste underliggende score.",
  systemMostSeriousStatus: "Laveste underliggende status",
  systemFilterAllLocations: "Alle lokasjoner",
  systemShowAll: "Vis alle",
  systemHideAll: "Skjul",
  systemCloseDetails: "Lukk detaljer",
  systemDetailsBoxTitle: "Detaljer",
  systemNoLocationScores: "Ingen lokasjoner med registrert score.",
  systemToggleScale: "Vis hele skalaen",
};

export const EN_TRANSLATIONS: TranslationTable = {
  syncToDbNoRows: "No valid rows (with ID) to import.",
  syncToDbDone: "Imported {count} interventions to the database.",
  syncToDbSystemDone:
    "System analysis: {criteria} criterion rows and {assessments} assessment rows.",
  syncToDbNoSystem: "No Annex4 worksheets in the file; the existing system analysis is unchanged.",
  syncToDbFailed: "Import failed:",
  syncToDbPartial:
    "The interventions were imported, but the system analysis failed. Please retry the import:",
  localFileError: "Could not read the file:",
  logout: "Log out",
  title: "Prevention system overview",
  tabList: "Intervention list",
  tabMatrix: "Intervention matrix",
  tabStats: "Prevention system statistics",
  tabSystem: "System analysis",
  tabAdmin: "Admin",
  listTitle: "Intervention list",
  listNumber: "ID",
  listName: "Intervention name",
  listLocation: "Location",
  arena: "Arena",
  listColor: "Classification",
  listLinks: "Links",
  listEdit: "Edit",
  listActions: "Actions",
  saveButton: "Save",
  deleteButton: "Delete intervention",
  deleteConfirm: "Are you sure you want to delete this intervention?",
  editTitleRequired: "Title cannot be empty.",
  editSaveError: "Could not save changes.",
  editRefreshError:
    "The intervention was saved, but the list could not be refreshed. Reload the page.",
  editDeleteError: "Could not delete intervention.",
  editApproveError: "Could not publish intervention.",
  editReturnError: "Could not return the intervention to draft.",
  approveButton: "Publish",
  returnButton: "Return to draft",
  returnToDraftConfirm: "Return this submitted intervention to draft? The respondent can then edit and resubmit it.",
  returnToDraftPublishedConfirm: "Return this published intervention to draft? It will disappear from the matrix and statistics until it is approved again.",
  feedbackReturnDialogTitle: "Return intervention to draft",
  feedbackCommentLabel: "Comment for respondent (optional)",
  feedbackCommentPlaceholder: "Explain what should be changed or added before resubmitting.",
  feedbackCommentHint: "Visible only to the respondent and authorized administrators.",
  feedbackRecipientMissing: "No respondent is assigned to this intervention. You can return it to draft without a comment.",
  feedbackTitle: "Feedback from administrator",
  feedbackPendingTitle: "Unacknowledged feedback ({count})",
  feedbackLater: "Show later",
  feedbackAcknowledge: "Acknowledge",
  feedbackAcknowledgeError: "Could not acknowledge the feedback.",
  feedbackAwaitingAcknowledgement: "Awaiting respondent acknowledgement.",
  feedbackRemainsPending: "The feedback remains pending and will appear when you open the intervention again.",
  feedbackPrevious: "Previous feedback ({count})",
  feedbackAcknowledged: "Acknowledged",
  feedbackNewCount: "{count} new feedback message(s) from administrator",
  feedbackListError: "Could not load feedback notifications.",
  saveDraftButton: "Save draft",
  submitButton: "Submit",
  statusDraft: "Draft",
  statusSubmitted: "Submitted",
  statusApproved: "Published",
  classificationHeading: "Classification",
  workingCommentsHeading: "Working comments",
  workingCommentsHint: "Internal notes, visible only to administrators.",
  workingCommentsEmpty: "No working comments.",
  lastUpdated: "Last updated",
  createdAt: "Created",
  changeHistory: "Change history",
  historyEmpty: "No changes recorded yet.",
  historyLoadError: "Could not load change history.",
  historyMore: "Show older events",
  historyCreated: "Intervention created",
  historyUpdated: "Intervention updated",
  historyStatus: "Status changed",
  historyDeleted: "Intervention deleted",
  historyCustomField: "Custom field changed",
  historyComment: "Working comment changed",
  historyQuestionnaire: "Questionnaire answers changed",
  historyChangedField: "Changed field",
  historyCharacters: "characters",
  updatedBy: "by",
  updatedByUnknown: "unknown",
  listStatus: "Status",
  newInterventionButton: "+ New intervention",
  respondentIntroTitle: "Welcome! Report prevention interventions here",
  respondentIntroText:
    "Register the prevention interventions in {location}. The list below shows the interventions you have registered, where you can also edit them.",
  respondentStepRegisterTitle: "Register",
  respondentStepRegisterText:
    "Save as a draft as you go. Submit when the intervention is fully described.",
  respondentStepReviewTitle: "Review",
  respondentStepReviewText:
    "Submitted interventions are locked and reviewed. An admin can return them to you as drafts.",
  respondentStepPublishedTitle: "Shown in the matrix",
  respondentStepPublishedText: "Published interventions become visible in the intervention matrix.",
  respondentSensitiveTitle: "Do not register sensitive data.",
  respondentSensitiveText:
    "Avoid personally identifiable information or other sensitive information in the descriptions.",
  respondentContact: "Questions about the tool? Contact the administrator for your location.",
  respondentIntroShow: "How it works",
  respondentIntroHide: "Hide guide",
  respondentListTitle: "Your reported interventions",
  newInterventionBadge: "New intervention",
  interventionEditorTitle: "Edit intervention",
  interventionEditorIntroduction:
    "Complete the sections below. The save button stays available at the bottom while you work.",
  respondentNoSubmissions: "You haven't registered any interventions yet.",
  detailsAge: "Age",
  detailsYears: "years",
  detailsNoDescription: "No description.",
  detailsNoSources: "No sources registered.",
  detailsSources: "Sources",
  formDisplayInformationTab: "Display information",
  formDataTab: "Form data",
  formDataNotice:
    "Form data is available only to the submitter, the local administrator for the intervention location, and the superadministrator. Display information is visible to everyone with read access to the intervention.",
  formFetchDisplayInformation: "Get display information from form data",
  formCopyConfirm:
    "This replaces the public fields specified in the questionnaire copy rules with values from the answers, including empty answers. Changes are published when you click Save. Continue?",
  formCopyDone:
    "The questionnaire answers have been copied to the public fields using the questionnaire copy rules. Click Save to save the changes.",
  formLoadError:
    "Could not load the private questionnaire. Check that the SQL migration has been applied, then reopen the intervention.",
  formUnknownVersion: "The questionnaire ID and version are not available in the code.",
  formNoResponse: "No questionnaire answers have been reported for this intervention.",
  formInvalidNumber:
    "Number fields must contain valid, non-negative whole numbers. From-age must not exceed to-age.",
  formChooseLocation: "Select a registered location to load its questionnaire.",
  adminLocationQuestionnaire: "Questionnaire for new submissions",
  adminGdprTitle: "GDPR",
  adminGdprDescription:
    "See the number of submitted questionnaire responses per location and delete responses according to the applicable retention schedule. Public intervention data will be kept.",
  adminGdprColId: "ID",
  adminGdprColName: "Location",
  adminGdprColCount: "Questionnaire responses",
  adminGdprColActions: "Action",
  adminGdprResponseCount: "{count} questionnaire responses",
  adminGdprResponsesDelete: "Delete responses",
  adminGdprResponsesConfirm:
    'Delete all {count} submitted questionnaire responses for "{location}"? The public intervention data will be kept. This action cannot be undone.',
  adminGdprResponsesDeleteSuccess:
    "Deleted {count} questionnaire responses for {location}. Public intervention data was kept.",
  adminGdprResponsesDeleteError: "Could not delete questionnaire responses.",
  formTitle: "Title",
  formDescription: "Description",
  formYoungest: "Youngest age",
  formOldest: "Oldest age",
  formLinksLabel: "Links (separated by semicolon)",
  respondentPageTitle: "Register an intervention",
  listEmpty: "No interventions match the selected filters.",
  labelView: "View:",
  location: "Location",
  objective: "Objective",
  labelFile: "Use local Excel file:",
  fileButton: "Choose File...",
  syncToDbButton: "Import to database",
  syncToDbButtonWorking: "Importing...",
  authGateTitle: "Intervention Matrix",
  authGateSubtitle: "Sign in with your email address to continue",
  authEmailLabel: "Email",
  authPasswordLabel: "Password",
  authLoginButton: "Sign in",
  authForgotButton: "Forgot password?",
  authErrorGeneric: "Sign in failed. Check your email and password.",
  authRoleInvalid:
    "This account has an unknown or outdated role. Check the role migration in Supabase, then sign out and sign in again.",
  authSessionExpired: "Your sign-in session could not be verified. Sign out and sign in again.",
  supabaseNotConfigured:
    "Sign-in is not set up for this installation. Contact the administrator (SUPABASE_URL and SUPABASE_ANON_KEY are missing).",
  authResetSent: "If the email exists, a password reset link has been sent.",
  authResetNeedsEmail: "Enter your email address first.",
  authSetPasswordSubtitle: "Welcome! Set a password to finish setting up your account.",
  authNewPasswordLabel: "New password",
  authConfirmPasswordLabel: "Confirm password",
  authSetPasswordButton: "Set password",
  authPasswordMismatch: "Passwords do not match.",
  authSetPasswordError: "Could not set password. Please try again, or request a new link.",
  adminPanelTitle: "User management",
  adminInviteHeading: "Invite new user",
  adminInviteEmailLabel: "Email",
  adminInviteRoleLabel: "Role",
  adminInviteRoleLocalAdmin: "Local administrator",
  adminInviteRoleLocalReader: "Local read access",
  adminInviteRoleRespondent: "Respondent",
  adminInviteRoleRespondentRead: "Respondent with read access",
  adminInviteRoleSuperAdmin: "Super administrator",
  adminInviteLocationLabel: "Location",
  adminInviteLocationPlaceholder: "Select a location",
  adminInviteSubmit: "Invite",
  adminUsersHeading: "Existing users",
  adminColEmail: "Email",
  adminColRole: "Role",
  adminColLocation: "Location",
  adminColActions: "Action",
  adminDeleteButton: "Delete",
  adminDeleteConfirm: "Are you sure you want to delete this user?",
  adminInviteSuccess: "User invited.",
  adminInviteError: "Could not invite user.",
  adminInviteLocationRequired: "Location is required for this role.",
  adminUsersLoadError: "Could not load user list.",
  adminUsersEmpty: "No users found.",
  adminDeleteError: "Could not delete user.",
  adminEditButton: "Edit",
  adminCancelButton: "Cancel",
  adminEditSelfHint: "You cannot change your own role.",
  adminEditNotAllowedHint:
    "Local administrators can only change readers and respondents in their own location.",
  adminRoleUpdated:
    "The role has been changed. It takes full effect when the user signs in again, within one hour at the latest.",
  adminRoleUpdateError: "Could not change the role.",
  adminLocationsTitle: "Location management",
  adminLocationCreateHeading: "Create a location",
  adminLocationIdLabel: "ID (two characters)",
  adminLocationNameLabel: "Name",
  adminLocationSubmit: "Create",
  adminLocationsHeading: "Existing locations",
  adminLocationColId: "ID",
  adminLocationColName: "Name",
  adminLocationIdLengthError: "Location ID must be exactly two characters.",
  adminLocationCreateSuccess: "Location created.",
  adminLocationCreateError: "Could not create location.",
  adminLocationsLoadError: "Could not load locations.",
  adminLocationsEmpty: "No locations found.",
  adminLocationDeleteConfirm: "Do you really want to delete the location",
  adminLocationDeleteError: "Could not delete location.",
  adminLocationDeleteAssignedError:
    "The location is assigned to users or has associated interventions and cannot be deleted.",
  adminAgeGroupsTitle: "Age columns in the intervention matrix",
  adminAgeGroupsDescription:
    "Choose 1–8 columns with Norwegian names and continuous age ranges without overlaps (0–120 years, inclusive). Manage translations under Languages and translations.",
  adminAgeGroupsName: "Column name",
  adminAgeGroupsFrom: "From age",
  adminAgeGroupsTo: "To age",
  adminAgeGroupsRemove: "Remove column",
  adminAgeGroupsAdd: "Add column",
  adminAgeGroupsSave: "Save age columns",
  adminAgeGroupsSaved: "Age columns saved.",
  adminAgeGroupsLoadError: "Could not load age columns. Reload the page.",
  adminAgeGroupsSaveError: "Could not save age columns.",
  adminAgeGroupsInvalidCount: "You must have between 1 and 8 columns.",
  adminAgeGroupsInvalidName: "Every column must have a name.",
  adminAgeGroupsInvalidRange:
    "Age limits must be whole numbers from 0 to 120, with the from age less than or equal to the to age.",
  adminAgeGroupsInvalidContinuous:
    "Ranges must be continuous without overlaps, from left to right. Each from age must equal the previous to age + 1.",
  adminAgeGroupsInvalidKey: "Columns have invalid identifiers. Reload the page.",
  adminArenasTitle: "Arenas / rows in the intervention matrix",
  adminArenasDescription:
    "Define any number of arenas (at least one) with Norwegian names and sort orders. Lowest numbers appear first; ties are sorted by name. Removing an arena keeps its interventions with an empty arena. Manage translations under Languages and translations.",
  languagesTitle: "Languages and translations",
  adminSubmenuLabel: "Admin settings",
  adminMenuUsers: "Users",
  adminMenuLocations: "Locations",
  adminMenuAgeGroups: "Age columns",
  adminMenuArenas: "Arenas",
  adminMenuExport: "Export",
  adminDefaultUrlTitle: "Default view",
  adminDefaultUrlDescription: "Defaults apply only to missing URL parameters. They never change access permissions. The data parameter applies only to workbook mode.",
  adminDefaultUrlLabel: "Default URL parameters",
  adminDefaultUrlSave: "Save default view",
  adminDefaultUrlSaved: "Default view saved. Reload to apply.",
  adminDefaultUrlError: "Invalid default parameters.",
  adminDefaultUrlViewUnavailable: "The default view is missing or hidden. Enable the view under Views",
  adminExportTitle: "Export data (CSV)",
  adminExportDescription:
    "Download data as CSV with the same columns the Excel import uses. Local administrators export data for their own location.",
  adminExportDatasetLabel: "Data",
  adminExportDatasetInterventions: "Interventions",
  adminExportDatasetSystemData: "System analysis – assessments (Annex4_Data)",
  adminExportDatasetSystemCriteria: "System analysis – criteria (Annex4_Criterion)",
  adminExportLocationLabel: "Location",
  adminExportAllLocations: "All locations",
  adminExportButton: "Export CSV",
  adminExportTemplateOnly: "Empty import template (column headers only)",
  adminExportTemplateButton: "Download empty CSV template",
  adminExportTemplateDone: "Downloaded empty CSV template.",
  adminExportWorking: "Exporting …",
  adminExportDone: "Exported {count} rows.",
  adminExportEmpty: "No rows found to export.",
  adminExportError: "Could not export data.",
  adminExportNoLocation: "Your user has no location. Contact a superadministrator.",
  adminExportSharedNote: "The criteria are shared by all locations and are exported together.",
  adminMenuExperimental: "Experimental features",
  adminExperimentalTitle: "Experimental features",
  adminExperimentalDescription:
    "Features under development that can be turned on for testing. They may change or be removed without notice.",
  adminExperimentalFeedbackLabel: "Feedback when returning an intervention",
  adminExperimentalFeedbackDescription: "Allows a comment when returning an intervention to draft. Respondents can acknowledge the feedback. Off by default.",
  adminExperimentalOverTimeLabel: "System analysis over time",
  adminExperimentalOverTimeDescription:
    "Adds an “Over time” view to System analysis that shows how each checkpoint has developed over the last years. Applies to all users.",
  adminExperimentalSaved: "The change is saved for all users.",
  adminExperimentalSaveError: "Could not save the change.",
  languagesDescription:
    "English is the master language. Translate interface texts, arenas, age columns and classifications in the groups below. Empty translations use English. Preserve placeholders such as {name} in messages. Intervention content is not translated here. Save new arenas and age columns first.",
  dictionaryNavigation: "Interface: navigation and search",
  dictionaryAdmin: "Interface: administration and languages",
  dictionaryAuth: "Interface: sign-in",
  dictionaryForms: "Interface: intervention forms and workflow",
  dictionarySystem: "Interface: system analysis",
  dictionaryStatistics: "Interface: statistics",
  dictionaryGeneral: "Interface: general texts and display",
  dictionaryClassifications: "Classification",
  dictionaryCategories: "Column categories",
  dictionaryObjectives: "Objectives",
  dictionarySearch: "Search translations",
  dictionarySearchEmpty: "No matches.",
  languageCsvExport: "Export CSV",
  languageCsvImport: "Import CSV",
  languageCsvHint:
    "Export includes all texts, languages and unsaved changes. Import updates entries and adds new languages as drafts. Save after importing.",
  languageCsvExported: "CSV file exported.",
  languageCsvImported:
    "Imported {entries} entries and {languages} new languages as drafts. Click Save languages and translations to save.",
  languageCsvConfirm:
    "Import {entries} entries and {languages} new languages? Texts in the file overwrite matching drafts. Other entries are retained. Changes apply only after saving.",
  languageCsvError: "Could not process the CSV file.",
  languageCsvSettings: "Correct invalid languages or English originals before exporting/importing.",
  languageCsvSyntax: "Invalid CSV: check quotation marks and delimiters.",
  languageCsvHeader: "The first row must be section;key;en and any other unique language codes.",
  languageCsvNames: "The second row must be languages;name followed by the name of each language.",
  languageCsvColumns: "All rows must have the same number of columns as the header.",
  languageCsvKey: "Unknown section or invalid text key.",
  languageCsvDuplicate: "The same section and text key occur more than once.",
  languageCsvUnregistered:
    "The file contains an arena or age column that is not registered. Create it first.",
  languageCsvEnglish: "English originals cannot be empty.",
  adminViewsTitle: "Views",
  adminCustomFieldsTitle: "Custom fields",
  adminCustomFieldsDescription: "Configure additional fields for interventions. Translate field labels under Languages and translations. English is the master language.",
  adminCustomFieldInvalidKey: "Field ID must start with a lowercase letter and otherwise contain only lowercase letters, digits and underscores.",
  adminCustomFieldRequiredEnglish: "English field name is required.",
  adminCustomFieldInvalidCss: "CSS class must be a single class name containing letters, digits, hyphens or underscores.",
  adminCustomFieldInvalidLocation: "You do not have access to this location.",
  adminCustomFieldLoadError: "Could not load custom fields.",
  adminCustomFieldSaveError: "Could not save the field.",
  adminCustomFieldDeleteError: "Could not delete the field.",
  adminCustomFieldDeleteConfirm: "Delete the field “{name}” and all its saved values? This cannot be undone.",
  adminCustomFieldNew: "New custom field",
  adminCustomFieldLoading: "Loading fields…",
  adminCustomFieldEmpty: "No custom fields yet.",
  adminCustomFieldAdd: "Add field",
  adminCustomFieldDefinition: "Field definition",
  adminCustomFieldNameEn: "Field name (English)",
  adminCustomFieldId: "Field ID",
  adminCustomFieldIdHint: "The field ID cannot be changed after creation. Translations are managed under Languages and translations.",
  adminCustomFieldPresentation: "Presentation",
  adminCustomFieldLocation: "Location",
  adminCustomFieldAllLocations: "All locations",
  adminCustomFieldType: "Field type",
  adminCustomFieldSingleLine: "Single-line text",
  adminCustomFieldMultiLine: "Multi-line text",
  adminCustomFieldSortOrder: "Display order",
  adminCustomFieldCssClass: "CSS class (optional)",
  adminCustomFieldCssHint: "Enter an existing stylesheet class name, not CSS rules.",
  adminCustomFieldAdminOnly: "Visible to administrators only",
  adminCustomFieldDelete: "Delete field",
  adminCustomFieldUnsaved: "Unsaved changes",
  adminCustomFieldNoChanges: "No unsaved changes",
  adminCustomFieldSaving: "Saving…",
  adminCustomFieldSave: "Save changes",
  adminCustomFieldCreate: "Create field",
  adminCustomFieldAdminBadge: "Admin",
  adminViewsDescription:
    "Edit views and categories. Changes apply only after saving. Built-in views can be hidden; custom views can be deleted. IDs, source fields and classification types are locked after saving. Categories used by interventions cannot be deleted. English and Norwegian names are also updated in translations.",
  adminViewSelect: "Select view",
  adminViewAdd: "New view",
  adminViewDiscard: "Discard new view",
  adminViewDelete: "Delete view",
  adminViewDeleteConfirm:
    'Delete the view "{name}"? When you save, it is removed from the view menu, the details panel and the intervention form, and the classification values in the field "{field}" are deleted from all interventions, including inactive ones. This cannot be undone.',
  adminViewDeleteConfirmShared:
    'Delete the view "{name}"? When you save, it is removed from the view menu, the details panel and the intervention form. The classification values in the field "{field}" are kept, because another view uses the same field. The deletion cannot be undone after saving.',
  adminViewsSave: "Save views",
  adminViewsSaved: "Views saved.",
  adminViewsError: "Could not save views.",
  adminViewsLoadError: "Could not load views. Check that supabase/schema.sql has been run.",
  adminViewsInvalid:
    "Check required names, unique IDs/codes, category order and that at least one view is visible.",
  adminViewId: "View ID (stable)",
  adminViewNameEn: "English name",
  adminViewNameNo: "Norwegian name",
  adminViewColumn: "Source field in intervention data / Excel",
  adminViewNewColumn: "New classification field",
  adminViewType: "Classification type",
  adminViewNumeric: "Numeric prefix (0–9)",
  adminViewCategorical: "Category code (lowercase letters, digits and hyphens)",
  adminViewLayout: "Column layout",
  adminViewOrder: "Sort order",
  adminViewVisible: "Visible in the view menu",
  adminViewChips: "Filter chips",
  adminViewChipsHidden: "None",
  adminViewChipsView: "View categories",
  adminViewChipsObjectives: "Objectives",
  adminViewDetails: "Classifications in the details panel",
  adminViewCategories: "Categories",
  adminViewCategoryAdd: "Add category",
  adminViewCategoryCode: "Category code (stable)",
  adminViewColor: "Background colour",
  adminViewPattern: "Pattern",
  adminViewSolid: "Solid",
  adminViewStriped: "Stripes",
  adminViewStripeColor: "Stripe colour",
  adminViewStripeBackground: "Second stripe colour",
  adminViewTextColor: "Text colour",
  adminViewTextAuto: "Automatic",
  adminViewTextBlack: "Black",
  adminViewTextWhite: "White",
  adminViewUp: "Move up",
  adminViewDown: "Move down",
  adminViewRemove: "Remove category",
  adminViewRemoveConfirm:
    "Remove this category? Deleting categories used by interventions will be blocked when saving.",
  adminViewCategoryUsed: "This category is used by an intervention and cannot be removed.",
  adminViewUntitled: "Untitled",
  adminViewNewBadge: "New",
  adminViewHiddenBadge: "Hidden",
  adminViewSectionNames: "Name",
  adminViewSectionSource: "Data source",
  adminViewSectionDisplay: "Display",
  adminViewLockedHint:
    "Locked after saving because classified interventions depend on these values.",
  adminUnsavedChanges: "Unsaved changes",
  adminAllChangesSaved: "All changes saved",
  languageMaster: "English original (master language)",
  languageTranslation: "Translation",
  languageCode: "Language code (e.g. sv or pt-br)",
  languageName: "Language name",
  languageAdd: "Add language",
  languageDelete: "Delete language",
  languageDeleteConfirm:
    "Really delete the language “{name}”? When you save, its language button and dictionary translations will be removed. Interventions and English originals are retained. If this language is selected, the interface will switch to English.",
  languageSectionLanguages: "Languages",
  languageSectionCsv: "Import and export (CSV)",
  languageSectionTranslations: "Translations",
  languageSourceBadge: "Source language",
  languageKey: "Text key",
  languageOnlyUntranslated: "Show only untranslated",
  languageUntranslatedBadge: "Untranslated",
  languageSearchCount: "{count} matches",
  languageGroupEmpty: "No texts in this group.",
  languageAllTranslated: "Everything in this group is translated.",
  languagesSave: "Save languages and translations",
  languagesSaved: "Languages and translations saved.",
  languagesError: "Could not save languages and translations.",
  languagesInvalid:
    "Enter unique lowercase language codes and names. English must be retained. English originals cannot be empty.",
  languagesLoadError: "Could not load languages and translations. Reload the page.",
  adminArenasName: "Arena name",
  adminArenasOrder: "Sort order",
  adminArenasAdd: "Add arena",
  adminArenasRemove: "Remove arena",
  adminArenasSave: "Save arenas",
  adminArenasSaved: "Arenas saved.",
  adminArenasLoadError: "Could not load arenas. Reload the page.",
  adminArenasSaveError: "Could not save arenas.",
  adminArenasInvalidCount: "You must have at least one arena.",
  adminArenasInvalidKey: "Arenas have invalid identifiers. Reload the page.",
  adminArenasInvalidName: "Every arena must have a name.",
  adminArenasInvalidOrder: "Sort order must be an integer between -2147483648 and 2147483647.",
  adminArenasRemoveConfirm:
    "Really remove the arena “{name}”? When you save, the Arena field will be cleared on all associated interventions, including inactive ones. The interventions are not deleted, but will not appear in the matrix until assigned a new arena.",
  formArenaPlaceholder: "Select an arena",
  formArenaRequired: "Select a registered arena.",
  formAgeRequired:
    "Enter the youngest and oldest age (whole numbers, youngest no higher than oldest).",
  searchPlaceholder: "Search interventions...",
  searchClear: "Clear search",
  allLocations: "All locations",
  locationsSelected: "locations selected",
  allObjectives: "All objectives",
  objectivesSelected: "objectives selected",
  infoDefault: "Click on an element in the matrix for details",
  statsTitle: "Prevention system statistics",
  tiltaksnivaTitle: "Number of interventions by Prevention level:",
  regionTitle: "Number of interventions by Location:",
  sectorTitle: "Number of interventions by Sector:",
  ageTitle: "Number of interventions by Age group:",
  tiltaksklasseTitle: "Number of interventions by Intervention class:",
  initialFilteringTitle: "Number of interventions by RePS initial classification:",
  kunnskapTitle: "Number of interventions by Knowledge foundation:",
  evidencelevelTitle: "Number of interventions by Evicence level:",
  stackedAgeTitle: "Interventions by Age group stacked by Evidence level",
  stackedTiltaksklasseTitle: "Interventions by Intervention class stacked by Evidence level",
  stackedInitialFilteringTitle:
    "Interventions by RePS initial classification stacked by Evidence level",
  stackedTiltakTitle: "Interventions by Prevention level stacked by Evidence level",
  stackedSectorTitle: "Interventions by Sector stacked by Evidence level",
  forklaring: "Legend:",
  unclassifiedItems: "Unclassified",
  ikkeAngitt: "Not specified",
  ingen: "None",
  showLabels: "Show labels",
  hideLabels: "Hide labels",
  labels: "Labels",
  noLabels: "No labels",
  labelsOn: "Titles: On",
  labelsOff: "Titles: Off",
  showItemIds: "Show IDs",
  hideItemIds: "Hide IDs",
  ids: "IDs",
  noIds: "No IDs",
  idsOn: "ID: On",
  idsOff: "ID: Off",
  moreDetails: "More details",
  detailsLevel0: "Details: Fewer",
  detailsLevel1: "Details: More 1",
  detailsLevel2: "Details: More 2",
  showMoreDetails: "Show more details",
  hideMoreDetails: "Show even more details",
  hideMoreDetails2: "Hide more details",
  listDescription: "Description",
  readMore: "Read more",
  showUnclassified: "Show unclassified",
  hideUnclassified: "Hide unclassified",
  unclassified: "Show unclassified",
  noUnclassified: "Hide unclassified",
  unclassifiedShow: "Unclassified: Show",
  unclassifiedHide: "Unclassified: Hide",
  showAll: "Show all",
  hideAll: "Hide all",
  showFilters: "Show filters",
  hideFilters: "Hide filters",
  filtersShow: "Filters: Show",
  filtersHide: "Filters: Hide",
  closeDetails: "Close details",
  moveDetailsRight: "Move details to the right",
  moveDetailsBelow: "Move details below the matrix",
  systemLocation: "Location",
  systemAnalysis: "Analysis",
  systemAbout: "About the system analysis",
  systemAboutTitle: "About the system analysis",
  systemAboutText:
    "The system analysis summarizes prevention capacity across six domains (A-F). Each checkpoint is assessed individually. The A-F colour badges show the most serious status among the underlying checkpoints.",
  systemSummaryLabel: "Explanation",
  systemDomain: "System domain",
  systemCriterion: "Criterion",
  systemAssessment: "Score",
  systemEvidence: "Assessment",
  systemSource: "Source / documentation",
  systemWorkingComment: "Working comment",
  systemSector: "Sector",
  systemInterventionType: "Intervention type",
  systemInterventionReach: "Intervention reach",
  systemNoCriteria: "No checkpoints available.",
  systemCreateAnalysis: "Create system analysis",
  systemEditAnalysis: "Edit analysis",
  systemCreateAnalysisTitle: "Create system analysis",
  systemEditAnalysisTitle: "Edit system analysis",
  systemCreateAnalysisDescription:
    "Work through the criteria at your own pace. Scores and notes are optional, so you can save and continue later.",
  systemCreateAnalysisYear: "Year",
  systemCreateAnalysisLocation: "Location",
  systemCreateAnalysisCriteriaSet: "Criteria",
  systemCreateAnalysisChooseCriteriaSet: "Choose a set of criteria…",
  systemCreateAnalysisCriteriaSetOption: "Criteria from {year} ({count})",
  systemCreateAnalysisCriteriaSetRequired: "Choose which set of criteria the analysis is based on.",
  systemCreateAnalysisChooseScore: "Choose score",
  systemCreateAnalysisAssessment: "Assessment",
  systemAnalysisAssessmentDetails: "Assessment details (English)",
  systemAnalysisNextLevel: "What was not met, and what the next level would require",
  systemCreateAnalysisCancel: "Cancel",
  systemCreateAnalysisSave: "Save analysis",
  systemCreateAnalysisSuccess: "System analysis saved.",
  systemCreateAnalysisError: "Could not save the system analysis.",
  systemCreateAnalysisDuplicate: "A system analysis already exists for this location and year.",
  systemCreateAnalysisNoCriteria: "There are no criteria to assess.",
  systemCreateAnalysisRefreshError:
    "The analysis was saved, but the view could not be refreshed. Reload the page.",
  systemAnalysisLastChanged: "Last changed",
  systemAnalysisLoadError:
    "Could not load the system analysis. The intervention list has loaded. Update the database schema or contact an administrator.",
  databaseLoadError: "Could not load interventions from the database:",
  systemNoSelection: "Select a checkpoint to view details",
  systemFulfilled: "Fully fulfilled",
  systemAlmostFulfilled: "Almost fully",
  systemPartiallyFulfilled: "Partially",
  systemOnlyLimited: "Only limited",
  systemNotFulfilled: "Not at all",
  systemInsufficientInformation: "Insufficient information",
  systemZero: "Not relevant",
  systemViewLabel: "View",
  systemViewSingle: "Single analysis",
  systemViewOverTime: "Over time",
  systemPeriod: "Period",
  systemNotAssessed: "Not assessed",
  systemPeriodAll: "All",
  systemPeriodLastTwo: "Last 2 years",
  systemFirstAnalysisPill: "{year} · first analysis",
  systemOverTimeTitle: "System analysis over time",
  systemOverTimeNoData: "No system analyses for this location yet.",
  systemCheckpoint: "Checkpoint",
  systemSince: "Since {year}:",
  systemImproved: "{count} improved",
  systemWorse: "{count} worse",
  systemOverallScore: "Overall score",
  systemFirstAnalysisNote: "First analysis – the baseline for next year’s comparison",
  systemFirstAnalysisTitle:
    "This is {location}’s first system analysis – the {year} bubbles are waiting to be filled in",
  systemFirstAnalysisText:
    "Run the {year} analysis to see which checkpoints have moved up, and where to focus next.",
  systemPlanAnalysis: "Plan the {year} analysis",
  systemUnknown: "Unknown",
  systemLegendFulfilled: "The criterion is fulfilled.",
  systemLegendAlmostFulfilled: "The criterion is almost fully fulfilled.",
  systemLegendPartiallyFulfilled: "The criterion is partially fulfilled.",
  systemLegendOnlyLimited: "The criterion is only fulfilled to a limited degree.",
  systemLegendNotFulfilled: "The criterion is not fulfilled at all.",
  systemLegendInsufficientInformation:
    "There is not sufficient information to assess the criterion.",
  systemLegendZero: "The criterion is not relevant.",
  systemAggregateRule:
    "The A-F colour badges show the most serious status among the underlying checkpoints.",
  systemMostSeriousStatus: "Most serious status",
  systemFilterAllLocations: "All locations",
  systemShowAll: "Show all",
  systemHideAll: "Hide",
  systemCloseDetails: "Close details",
  systemDetailsBoxTitle: "Details",
  systemNoLocationScores: "No locations with a recorded score.",
  systemToggleScale: "Show full scale",
};
